<div class="rounded-md bg-gray-50 p-16">
  <div class="grid grid-cols-2 items-center gap-4">
    <div class="flex flex-col">
      <div class="mb-6 text-3xl font-bold text-gray-600">
        Twój koszyk jest pusty
      </div>

      <div class="text-sm text-gray-500">
        Wygląda na to, że jeszcze nic nie dodałeś do koszyka.<br />
        Sprawdź nasze boxy oraz produkty i znajdź coś dla siebie!
      </div>

      <div class="mt-6">
        <app-router-link
          [contents]="true"
          [route]="Route.PL_Boxes">
          <app-slim-button
            [fluid]="true"
            label="Kontynuuj zakupy"
            maxWidth="16rem"
            theme="dark" />
        </app-router-link>
      </div>
    </div>

    <div class="flex justify-center">
      <svg
        class="fill-gray-600"
        viewBox="0 0 4900 4651"
        width="15rem"
        xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_2001_13)">
          <path
            d="M4 0V180.3H557.9C692.2 180.3 808.1 271.5 839.5 402.2L1345.8 2504L1480.4 3057C1531.8 3268.3 1719.6 3415.9 1937.1 3415.9H4039C4256.5 3415.9 4444.3 3268.3 4495.7 3057L4881.8 1470.5C4916.1 1329.4 4884.4 1183.1 4794.7 1068.9C4705 954.8 4570.3 889.3 4425.1 889.3H1142.4L1014.9 359.9C963.8 148 775.9 0 557.9 0H4ZM1185.8 1069.7H4425.1C4514.6 1069.7 4597.6 1110.1 4652.9 1180.4C4708.2 1250.7 4727.7 1341 4706.6 1427.9L4320.5 3014.3C4288.8 3144.5 4173.1 3235.5 4039 3235.5H1937.1C1803.1 3235.5 1687.3 3144.6 1655.6 3014.3L1185.8 1069.7Z" />
          <path
            d="M1291.2 4146.5C1291.2 4419.9 1513.6 4642.3 1787 4642.3C2060.4 4642.3 2282.8 4419.9 2282.8 4146.5C2282.8 3873.1 2060.4 3650.7 1787 3650.7C1513.6 3650.7 1291.2 3873.1 1291.2 4146.5ZM1471.5 4146.5C1471.5 3972.5 1613 3831 1787 3831C1960.9 3831 2102.5 3972.5 2102.5 4146.5C2102.5 4320.4 1961 4462 1787 4462C1613.1 4462 1471.5 4320.5 1471.5 4146.5Z" />
          <path
            d="M3693.3 4146.5C3693.3 4419.9 3915.7 4642.3 4189.1 4642.3C4462.5 4642.3 4684.9 4419.9 4684.9 4146.5C4684.9 3873.1 4462.5 3650.7 4189.1 3650.7C3915.7 3650.7 3693.3 3873.1 3693.3 4146.5ZM3873.6 4146.5C3873.6 3972.5 4015.1 3831 4189.1 3831C4363 3831 4504.6 3972.5 4504.6 4146.5C4504.6 4320.4 4363.1 4462 4189.1 4462C4015.2 4462 3873.6 4320.5 3873.6 4146.5Z" />
          <path
            d="M2270 1812.5C2216.7 1812.5 2159.7 1801.6 2099.2 1779.7C2079.3 1772.5 2069 1750.5 2076.2 1730.6C2083.4 1710.7 2105.4 1700.4 2125.3 1707.6C2229.2 1745.2 2318.9 1745 2391.9 1707.2C2507.8 1647.3 2546 1512.7 2546.4 1511.3C2552 1490.9 2573.1 1478.9 2593.5 1484.5C2613.9 1490.1 2625.9 1511.2 2620.3 1531.6C2618.4 1538.4 2572.4 1700 2427.1 1775.2C2379.2 1800 2326.7 1812.3 2270 1812.3V1812.5Z" />
          <path
            d="M3630.7 1780.7C3573.9 1780.7 3521.4 1768.3 3473.6 1743.6C3328.3 1668.4 3282.3 1506.9 3280.4 1500C3274.8 1479.6 3286.8 1458.5 3307.2 1452.9C3327.6 1447.3 3348.7 1459.2 3354.3 1479.6C3354.8 1481.4 3394.2 1616.6 3509.4 1675.8C3582.4 1713.3 3671.9 1713.3 3775.5 1675.8C3795.4 1668.6 3817.4 1678.9 3824.6 1698.8C3831.8 1718.7 3821.5 1740.7 3801.6 1747.9C3741.2 1769.7 3684.1 1780.7 3630.8 1780.7H3630.7Z" />
          <path
            d="M2563.3 2756.8C2547 2756.8 2530.8 2750.6 2518.3 2738.3C2493.2 2713.5 2493.1 2673 2517.9 2647.9C2527.1 2638.6 2747.7 2419.3 3035.3 2425.2C3199.9 2428.5 3350.8 2504.1 3483.8 2649.8C3507.6 2675.9 3505.8 2716.3 3479.7 2740.1C3453.6 2763.9 3413.2 2762.1 3389.4 2736C3281.1 2617.5 3161.4 2555.9 3033.5 2553C3030.4 2553 3027.3 2552.9 3024.2 2552.9C2908.2 2552.9 2803.9 2600.8 2736.2 2641.7C2658.1 2688.7 2609.1 2737.5 2608.6 2738C2596.1 2750.6 2579.7 2756.9 2563.3 2756.9V2756.8Z" />
          <path
            d="M2618.3 2047.5C2618.3 2143.8 2563.4 2221.8 2495.6 2221.8C2427.8 2221.8 2372.9 2143.7 2372.9 2047.5C2372.9 1951.3 2427.8 1873.2 2495.6 1873.2C2563.4 1873.2 2618.3 1951.3 2618.3 2047.5Z" />
          <path
            d="M3627.1 2047.5C3627.1 2143.8 3572.2 2221.8 3504.4 2221.8C3436.6 2221.8 3381.7 2143.7 3381.7 2047.5C3381.7 1951.3 3436.6 1873.2 3504.4 1873.2C3572.2 1873.2 3627.1 1951.3 3627.1 2047.5Z" />
        </g>
        <defs>
          <filter
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
            height="4650.3"
            id="filter0_d_2001_13"
            width="4899.31"
            x="0"
            y="0">
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite
              in2="hardAlpha"
              operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend
              in2="BackgroundImageFix"
              mode="normal"
              result="effect1_dropShadow_2001_13" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_2001_13"
              mode="normal"
              result="shape" />
          </filter>
        </defs>
      </svg>
    </div>
  </div>
</div>
